import React from 'react';
import {Box} from '@mui/material';

import Header from '../Header/Header';

// 테마/CssBaseline 은 App 최상단 ThemeProvider 로 이동 (Login 포함 전 화면 공용)
function MainBox(props: any) {
    return (
        <Box sx={{ display: 'flex' }}>
            <Header />
            <Box
                component='main'
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto'
                }}
            >
                {props.children}
            </Box>
        </Box>
    );
}

export default MainBox;
